
import { defineComponent } from 'vue';

export default defineComponent({
  props: ['doPrint', 'printSizeOptions', 'isDisabled'],
  setup() {},
  data() {
    return {
      pageId: 5
    };
  },
  watch: {
    printSizeOptions: {
      handler(val) {
        this.pageId = val[0].id;
      },
      deep: true
    }
  },
  methods: {
    handleChange(value) {
      this.pageId = value;
    }
  }
});
